(() => {
  'use strict';
  if (window.__mgHomeAccessV1) return;
  window.__mgHomeAccessV1 = true;
  let pendingPrompt = null;
  let installedThisSession = false;
  const mode = window.matchMedia('(display-mode: standalone)');
  const ua = navigator.userAgent || '';
  const ios = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const android = /Android/i.test(ua);
  const platform = ios ? 'ios' : android ? 'android' : 'desktop';
  const standalone = () => mode.matches || navigator.standalone === true || installedThisSession;
  const entries = () => [...document.querySelectorAll('[data-mg-home-access]')];
  const sync = () => entries().forEach(entry => {
    entry.hidden = standalone();
    if (platform === 'desktop') entry.querySelector('[data-home-access-label]').textContent = entry.dataset.desktopLabel;
    entry.querySelectorAll('[data-home-access-platform]').forEach(block => { block.hidden = block.dataset.homeAccessPlatform !== platform; });
    entry.querySelector('[data-home-access-close]').hidden = false;
    entry.querySelector('[data-home-access-native]').hidden = !android || !pendingPrompt || standalone();
  });
  window.addEventListener('beforeinstallprompt', event => {
    if (event.isTrusted !== true || !android || standalone() || typeof event.prompt !== 'function') return;
    event.preventDefault();
    pendingPrompt = event;
    sync();
  });
  window.addEventListener('appinstalled', event => { if (event.isTrusted !== true) return; pendingPrompt = null; installedThisSession = true; sync(); });
  mode.addEventListener?.('change', sync);
  window.addEventListener('pageshow', sync);
  document.addEventListener('shopify:section:load', sync);
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const close = event.target.closest('[data-home-access-close]');
    if (close) {
      const entry = close.closest('[data-mg-home-access]');
      entry.open = false; entry.querySelector('summary').focus(); return;
    }
    const button = event.target.closest('[data-home-access-native]');
    if (!button || event.isTrusted !== true) return;
    const entry = button.closest('[data-mg-home-access]');
    const result = entry.querySelector('[data-home-access-result]');
    const prompt = pendingPrompt;
    if (!android || standalone() || !prompt) { result.textContent = result.dataset.fallback; sync(); return; }
    pendingPrompt = null;
    button.disabled = true;
    try {
      await prompt.prompt();
      if (prompt.userChoice) await prompt.userChoice;
      result.textContent = result.dataset.returned;
    } catch (_) {
      result.textContent = result.dataset.fallback;
    } finally {
      button.disabled = false;
      sync();
      if (!entry.hidden) entry.querySelector('[data-home-access-close]').focus();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const entry = event.target.closest('[data-mg-home-access]');
    if (entry?.open) { entry.open = false; entry.querySelector('summary').focus(); }
  });
  sync();
})();
